<!--
 * @Author: qinmengyuan
 * @Date: 2024-08-20 18:36:20
 * @LastEditors: qinmengyuan 2715025514@qq.com
 * @LastEditTime: 2024-08-21 17:08:46
 * @FilePath: \onetab\src\components\ShareListModal.vue
-->
<template>
  <RaDialog
    width="720px"
    :model-value="visible"
    :before-close="handleClose"
    :append-to-body="true"
    class="list-modal"
    title="我的分享"
  >
    <RaTable
      :data="tableData"
      style="width: 100%"
      headerFill="none"
      @current-change="handleCurrentChange"
      highlight-current-row
      @cell-mouse-enter="handleHoverRow"
    >
      <RaTableColumn type="selection" width="35" />
      <RaTableColumn
        show-overflow-tooltip
        prop="name"
        width="148"
        label="分享书签"
      />
      <RaTableColumn width="100">
        <template #default="scope">
          <div
            v-if="active === scope.row.id"
            class="link"
            @click="handleCopy(scope.row)"
          >
            <RaIcon icon="Link" />
            复制链接
          </div>
        </template>
      </RaTableColumn>
      <RaTableColumn width="100">
        <template #default="scope">
          <div
            v-if="active === scope.row.id"
            class="link"
            @click="handleCancel(scope.row)"
          >
            <RaIcon icon="Stop" />
            取消分享
          </div>
        </template>
      </RaTableColumn>
      <RaTableColumn prop="created_at" label="分享时间" width="160" />
      <RaTableColumn label="浏览次数"> 0 </RaTableColumn>
    </RaTable>
    <ShareCancelModal
      :visible="cancelVisible"
      @close="handleCloseDeleteModal"
      :value="deleteId"
    />
  </RaDialog>
</template>

<script setup>
import { ref, onMounted, watch } from 'vue';
import {
  RaDialog,
  RaInput,
  RaCheckboxGroup,
  RaCheckbox,
  RaMessage,
  RaButton,
  RaTable,
  RaTableColumn,
} from '@rafter/pc';
import { RaIcon } from '@rafter/icon';
import { getSharesList } from '@/api/baseApi';
import ShareCancelModal from './ShareCancelModal.vue';
const emits = defineEmits(['close']);
const cancelVisible = ref(false);
const tableData = ref([]);
const inputValue = ref('');
const active = ref('');
const deleteId = ref('');
const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  value: {
    type: String,
    default: '',
  },
});
watch(
  () => props.visible,
  () => {
    if (props.visible) {
      getSharesList().then((res) => {
        if (res.data.code === 200) {
          tableData.value = res.data.data;
        }
      });
    }
  }
);
onMounted(() => {
  getSharesList().then((res) => {
    if (res.data.code === 200) {
      tableData.value = res.data.data;
    }
  });
});
const handleClose = () => {
  emits('close');
};
const handleCopy = async (item) => {
  let link;
  if (!window.location.href.includes('chrome-extension')) {
    link = window.location.href + 'share' + `?code=${item.code}`;
  } else {
    link = 'https://mitab.bimcc.net/share?code=' + `${item.code}`;
  }
  await navigator.clipboard.writeText(link);
  RaMessage.success('复制成功');
};
const handleCancel = (item) => {
  cancelVisible.value = true;
  deleteId.value = item.id;
};
const handleHoverRow = (item) => {
  active.value = item.id;
};
const handleCloseDeleteModal = (refresh) => {
  cancelVisible.value = false;
  if (refresh) {
    getSharesList().then((res) => {
      if (res.data.code === 200) {
        tableData.value = res.data.data;
      }
    });
  }
};
</script>
<style lang="scss">
.list-modal {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin: 0 !important;
  border-radius: 24px !important;
  height: 560px;
  @include background_color('base-bg-color-09');
  backdrop-filter: blur(40px);
  .ra-dialog__header {
    padding: 16px 24px !important;
    .ra-dialog__title {
      @include font_color('text-on-surface-secondary');
      font-family: 'PingFang SC';
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: 24px; /* 150% */
    }
  }
  .ra-dialog__body {
    padding: 0 24px 24px !important;
    display: flex;
    flex-direction: column;
    .ra-table--fit {
      background: transparent !important;
      tr {
        background: transparent !important;
      }
      .ra-scrollbar {
        background: transparent !important;
      }
      .ra-table__header {
        .ra-table__cell {
          padding: 0;
          border-bottom: 1px solid rgba(26, 26, 26, 0.05);
          .cell {
            color: var(--Text-on-surface-tertiary, #787f8f);
            font-family: 'PingFang SC';
            font-size: 12px;
            font-style: normal;
            font-weight: 500;
            line-height: 18px; /* 150% */
            padding: 0 12px;
          }
        }
      }
      .ra-table__custom-row {
        display: none;
      }
      .ra-table__body {
        .ra-table__row {
          &:hover {
            td:not(.ra-table__expanded-cell) {
              @include background_color('background-overlay');
            }
          }
        }
        .ra-table__cell {
          padding: 9px 0;
          border-bottom: 1px solid rgba(26, 26, 26, 0.05);

          .cell {
            overflow: hidden;
            @include font_color('text-on-surface-primary');
            text-overflow: ellipsis;
            font-family: 'PingFang SC';
            font-size: 13px;
            font-style: normal;
            font-weight: 400;
            line-height: 20px; /* 153.846% */
            padding: 0 12px;
          }
        }

        .ra-table_1_column_1 {
          border-radius: 8px 0 0 8px;
        }
        .ra-table_1_column_6 {
          border-radius: 0 8px 8px 0;
        }
        .current-row {
          .ra-table__cell {
            @include background_color('background-overlay');
          }

          .ra-table_1_column_1 {
            border-radius: 8px 0 0 8px;
          }
          .ra-table_1_column_6 {
            border-radius: 0 8px 8px 0;
          }
        }
        .link {
          color: var(--One-Selected, #007aff);
          font-family: 'PingFang SC';
          font-size: 13px;
          font-style: normal;
          font-weight: 400;
          line-height: 20px; /* 153.846% */
          cursor: pointer;
          display: flex;
          align-items: center;
          gap: 4px;
        }
      }
    }
  }
}
</style>
